module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Tools/Axe-9dbb5d7e0c6bfd1b108642993edaadb47fed93d69ffb72e29377623ae8c90ee6.svg";